import { Link, useStaticQuery, graphql } from "gatsby"
import React from "react"
import styles from "./header.module.scss"
import logo from "../images/logo_isba.png"

/* BURGER MENU */
const ToggleMenuBtn = (props) => (
  <button className="fixed inset-x-0 bottom-0 flex h-12 justify-center items-center border-t border-black w-full bg-white lg:hidden" onClick={props.onClick}>
    <p className="font-semibold mr-5">Navigation</p>
    <div className="h-4 w-6 border-solid flex flex-col justify-between  cursor-pointer z-20">
      <div className="border border-black  w-full h-1 rounded-full"></div>
      <div className="border border-black  w-full h-1 rounded-full"></div>
      <div className="border border-black  w-full h-1 rounded-full"></div>
    </div>
  </button>
)

/* NAVIGATION BAR */
const NavLink = (props) => <Link className={`hover:text-primary duration-100 transition-colors font-semibold flex-auto flex items-center justify-center mx-2 lg:m-0 lg:py-4 lg:px-6 border-t lg:border-t-0 border-black last:pr-0 ${styles.fcNoBorderTop}`} activeClassName="text-primary" to={props.link} onClick={props.onClick}>{ props.text }</Link>

class NavBar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false,
      expandClass: "top-100/100"
    }

    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand () {
    if (this.state.expanded) {
      this.setState({
        expandClass: "top-100/100"
      })
    } else {
      this.setState({
        expandClass: "bottom-12 top-0"
      })
    }

    this.setState( (state) => ({ expanded: !state.expanded}) )
  }

  render () {
    return (
      <>
        <nav className={`fixed inset-x-0 bottom-0 bg-white flex flex-col justify-center text-center z-20 inset-x-0 overflow-hidden duration-75 lg:static lg:flex-row ${this.state.expandClass}`}>
          <NavLink onClick={this.toggleExpand} text="Accueil"    link="/"/>
          <NavLink onClick={this.toggleExpand} text="Catalogue"  link="/catalogue/"/>
          <NavLink onClick={this.toggleExpand} text="Articles"   link="/articles"/>
          <NavLink onClick={this.toggleExpand} text="Manuscrits" link="/manuscrits"/>
          <NavLink onClick={this.toggleExpand} text="Contact"    link="/contact/"/>
        </nav>
        <ToggleMenuBtn onClick={this.toggleExpand}/>
      </>
    )
  }
}

/* HEADER */
const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      dataJson {
          title
          subtitle
      }
    }
  `)
  return (
    <header className="z-50 border-b border-black bg-white">
      <div className="mx-auto relative container py-4 px-8 flex items-center justify-between px-4">
        <Link to="/" className="w-full lg:w-auto flex justify-center items-center"> 
          <img className="h-32 sm:h-24 mr-8" src={logo} alt="Rond fait à l'encre, icomplet avec l'inscription 'les fabulantes'"/>
          <div className="lg:ml-0">
            {/* <h1 className="lg:text-left text-2xl sm:text-3xl font-serif font-bold text-primary">{data.dataJson.title}</h1> */}
            <h2 className="lg:text-left text-sm sm:text-lg font-serif font-bold">{data.dataJson.subtitle}</h2>
          </div>
        </Link>
        <div>
          <NavBar />
        </div>
      </div>
    </header>
  )
}

export default Header
